module.exports = __webpack_public_path__ + "static/media/Mehran Ebrahimi.a223ba70.png";